import { stationsActions } from '../reducer';

import { StationsState } from '../../types';

export const updateVisibleStations = (
  stations: StationsState['visibleStations']['data']) => stationsActions
  .setVisibleStations(stations);
